import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';

import { queryMap, queryKeys } from '@simple-city/service-graphql-schemas';

import * as actions from '../../actions';

import TermsOfServiceRedirect from '../../components/TermsOfService/TermsOfServiceRedirect';

const mapStateToProps = ({ auth: { profile }, location, venue }) => ({ profile, location, venue });

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

const withData = graphql(queryMap[queryKeys.Q_ME])(TermsOfServiceRedirect);

const TermsOfServiceRedirectContainer = connect(mapStateToProps, mapDispatchToProps)(withData);

export default TermsOfServiceRedirectContainer;



// WEBPACK FOOTER //
// ./src/containers/TermsOfService/TermsOfServiceRedirectContainer.js